import { shaderMaterial, useTexture } from "@react-three/drei";
import { extend } from "@react-three/fiber";
import { BackSide, Color, DoubleSide, RepeatWrapping } from "three";

import fragShader from "./skysphere_frag.glsl";
import vertShader from "./skysphere_vert.glsl";

import noiseTexture from "./grainnoise.png";
import { degToRad } from "three/src/math/MathUtils";

const GradientSphereMaterial = shaderMaterial(
  {
    topColor: new Color(1, 1, 1),
    bottomColor: new Color(0, 0, 0),
    noiseTexture: null,
    noiseStrength: 70,
    noiseScale: 50,
    offset: 0,
    uvMulti: 1,
  },
  vertShader,
  fragShader,
);

extend({ GradientSphereMaterial });

const SkySphere = ({ ...props }) => {
  const tex = useTexture(noiseTexture);
  tex.wrapS = RepeatWrapping;
  tex.wrapT = RepeatWrapping;

  return (
    <mesh rotation={[degToRad(-20), 0, degToRad(20)]}>
      <sphereGeometry args={[250]} />
      <gradientSphereMaterial
        key={GradientSphereMaterial.key}
        offset={0.675}
        uvMulti={0.7}
        bottomColor={new Color("#3f8660")}
        // bottomColor={new Color("#6b0000")}
        topColor={new Color("#000000")}
        noiseTexture={tex}
        noiseStrength={250}
        noiseScale={35}
        side={BackSide}
        depthWrite={false}
      />
    </mesh>
  );
};

export default SkySphere;
